import React from 'react';
import styles from './sales.module.scss';
import { KoAffix,  KoTabs, KoTitle } from 'packages';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';

const sales = () => {

  const TABS = [
    {
      key: 'estimates',
      label: <Link to="/paybooks/sales/estimates">Estimates</Link>,
      children:''
    },
    {
      key: 'retainerinvoices',
      label: <Link to="/paybooks/sales/retainerinvoices">Retainer Invoices</Link>,
      children:''
    },{
      key: 'salesorders',
      label: <Link to="/paybooks/sales/salesorder">Sales Order</Link>,
      children:''
    },{
      key: 'paybookinvoices',
      label: <Link to="/paybooks/sales/paybookinvoices">Invoices</Link>,
      children:''
    },{
      key: 'paymentsreceived',
      label: <Link to="/paybooks/sales/paymentreceived">Payments Received</Link>,
      children:''
    },{
      key: 'recurringinvoices',
      label: <Link to="/paybooks/sales/recurringinvoices">Recurring Invoices</Link>,
      children:''
    }
  ];

  return (
    <div className={`${styles.wrapper} profileSection`}>
      <KoAffix top={50}>
        <div className={styles.header}>
          <KoTitle text="sales" level={4} />
          <KoTabs options={TABS}  />
        </div>
      </KoAffix>
      <Outlet />
    </div>
  );
};

export default sales;